import React, { Component, PureComponent } from "react";
import CSSModules from "react-css-modules";
import PropTypes from "prop-types";

const defaultconf = {
	pure: true,
	forwardRef: true
};

/**
 * Extract consumer css from props.classes and merge into base css.
 * 
 * NOTE: any class names that match in props.classes and the base css will
 * override the base class of that name. Prefix base css classes with '_' or similiar char to
 * prevent this.
 * @param {*} component
 * @param {object} styles Components' base css
 * @param {defaultconf} conf See `defaultconf` object
 */
export default function MergeStyles(component, styles, conf) {
	conf = { ...defaultconf, ...conf };
	const base = conf.pure ? PureComponent : Component;
	//do this to merge css classes
	class StylesMerged extends base {
		static propTypes = {
			classes: PropTypes.object //style overrides
		};
		constructor(props) {
			super(props);
			this.state = {
				wrapped: CSSModules(
					component,
					{ ...styles, ...this.props.classes },
					{
						allowMultiple: true
					}
				)
			};
		}

		render() {
			const Elem = this.state.wrapped;
			return <Elem {...this.props} />;
		}
	}

	return conf.forwardRef
		? React.forwardRef((props, ref) => <StylesMerged {...props} forwardedRef={ref} />)
		: StylesMerged;
}



// WEBPACK FOOTER //
// ./src/utils/CSSModulesHoC.js